module.exports = __webpack_public_path__ + "static/media/bugsleuth_logo.040f5243.png";